import { module as BaseModule } from "modujs"

export default class extends BaseModule {
  init() {
    const button = this.el.querySelector("[data-accordion-button]")
    button.addEventListener("click", () => {
      const contentId = button.getAttribute("aria-controls")
      const content = document.getElementById(contentId)

      const isExpanded = button.getAttribute("aria-expanded") === "true"
      button.setAttribute("aria-expanded", !isExpanded)
      content.setAttribute("aria-hidden", isExpanded)
      content.classList.toggle("active")
    })
  }
}
